import EnrollPatientForm from './EnrollPatient';

export default EnrollPatientForm;
